import React, { useEffect, useState } from "react";
import "./Toast.css";

const Toast = ({ message, type = "info", duration = 5000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Make sure we're only setting these timers once per toast instance
    const fadeTimer = setTimeout(() => {
      setVisible(false);
    }, duration);

    const removeTimer = setTimeout(() => {
      // Ensure the onClose callback is called to remove from parent component
      if (onClose) onClose();
    }, duration + 300); // Animation time after fade out

    // Critical: Cleanup function to prevent memory leaks
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []); // Empty dependency array - run only once on mount

  return (
    <div className={`toast ${type} ${visible ? "visible" : "hidden"}`}>
      <div className="toast-content">
        {type === "success" && <span className="toast-icon">✓</span>}
        {type === "error" && <span className="toast-icon">✗</span>}
        {type === "info" && <span className="toast-icon">ℹ</span>}
        {message}
      </div>
    </div>
  );
};

export const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
